import React, { useEffect, useState, useReducer } from "react";
import { Card, CardBody } from "reactstrap";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import { endpoint } from "../../common/constant";
import AButton from "../../common/form-fields-mui/AButton";
import AAutoComplete from "../../common/form-fields-mui/AAutoComplete";
import { fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";

const AttachTestForm = ({
  closeForm,
  testData,
  planData,
  updateAttachTestHandler = () => {},
  isTimeTableEvent = false,
}) => {
  const [attachTestForm, setAttachTestForm] = useState(
    testData?.attachTestId === null || testData?.attachTestId === undefined
      ? null
      : { label: testData?.attachTestShortCode, value: testData?.attachTestId }
  );

  // Initial State
  const initialState = {
    multiSetTest: testData.isMultiSet || false,
    combinedResult: testData.hasCombinedSet || false,
    testGroupId: testData.testGroupId
      ? { label: testData.testGroupShortCode, value: testData.testGroupId }
      : "",
    isDropdownEnabled: testData.isMultiSet || testData.hasCombinedSet,
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [testIdDropdown, setTestIdDropdown] = useState([]);
  const [testGroupOptions, setTestGroupOptions] = useState([]);

  // Reducer Function
  function reducer(state, action) {
    switch (action.type) {
      case "TOGGLE_MULTI_SET_TEST": {
        const newMultiSetTest = !state.multiSetTest;
        const isDropdownEnabled = newMultiSetTest || state.combinedResult;
        return { ...state, multiSetTest: newMultiSetTest, isDropdownEnabled };
      }

      case "TOGGLE_COMBINED_RESULT": {
        const newCombinedResult = !state.combinedResult;
        const isDropdownEnabled = state.multiSetTest || newCombinedResult;
        return {
          ...state,
          combinedResult: newCombinedResult,
          isDropdownEnabled,
        };
      }

      case "SET_TEST_GROUP_ID":
        return { ...state, testGroupId: action.payload };

      default:
        return state;
    }
  }

  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    getTestDropdown();
  }, []);

  useEffect(() => {
    if (state.isDropdownEnabled && attachTestForm?.value)
      fetchTestGroupDropdown();
    else if (!state.isDropdownEnabled)
      dispatch({
        type: "SET_TEST_GROUP_ID",
        payload: "",
      });
  }, [state.isDropdownEnabled, attachTestForm]);

  const getTestDropdown = async () => {
    setIsFetching(true);
    const res = await fetchAllPromisedData(
      `${endpoint?.academicPlanTests?.getTestIdsFromCMS}?packageId=${planData?.packageId}&testCollectionId=${planData?.testCollectionId}&testType=${testData?.testType}`,
      true
    );
    if (res?.code === 200) {
      setTestIdDropdown(
        res?.data?.map((item) => ({
          label: item?.testShortCode,
          value: item?.id,
        }))
      );
    }
    setIsFetching(false);
  };

  const fetchTestGroupDropdown = async () => {
    setIsFetching(true);
    const res = await fetchAllPromisedData(
      `${endpoint?.academicPlanTests?.getTestGroupByTestId}/?testId=${attachTestForm.value}`,
      true
    );
    if (res?.code === 200) {
      setTestGroupOptions(
        res?.data?.testGroupDtoList.map((item) => ({
          label: item?.testGroupShortCode,
          value: item?.id,
        }))
      );
    } else setTestGroupOptions([]);
    setIsFetching(false);
  };

  return (
    <Card className="mb-0" style={{ width: "370px" }}>
      <CardBody>
        <h4 style={{ fontSize: "20px", fontWeight: 600, color: "#0F0F0F" }}>
          Test Paper
        </h4>
        <div className="d-flex flex-column">
          <AAutoComplete
            label="Test ID"
            placeholder="Select"
            currentValue={attachTestForm}
            items={testIdDropdown}
            handleChange={(value) => {
              setAttachTestForm(value);
              dispatch({
                type: "SET_TEST_GROUP_ID",
                payload: "",
              });
            }}
            isMulti={false}
            isLoading={isFetching}
          />

          {!isTimeTableEvent && (
            <>
              <FormControlLabel
                className="mt-3"
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
                control={
                  <Checkbox
                    size="small"
                    checked={state.multiSetTest}
                    onChange={() => dispatch({ type: "TOGGLE_MULTI_SET_TEST" })}
                    className="py-0"
                  />
                }
                label="Multi-set Test"
              />

              <FormControlLabel
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
                control={
                  <Checkbox
                    size="small"
                    checked={state.combinedResult}
                    onChange={() =>
                      dispatch({ type: "TOGGLE_COMBINED_RESULT" })
                    }
                    className="py-0"
                  />
                }
                label="Combined Result"
              />

              <AAutoComplete
                label="Test Group ID"
                placeholder="Select"
                currentValue={state.testGroupId}
                items={testGroupOptions}
                handleChange={(value) =>
                  dispatch({
                    type: "SET_TEST_GROUP_ID",
                    payload: value,
                  })
                }
                isMulti={false}
                isLoading={isFetching}
                isDisabled={!state.isDropdownEnabled || !attachTestForm?.value}
              />
            </>
          )}

          <div className="d-flex justify-content-end mt-3">
            <AButton
              variant="outline"
              updatedStyle={{
                height: "28px",
                fontSize: "12px",
                fontWeight: 400,
                borderWidth: "1px",
              }}
              onClick={closeForm}
            >
              Cancel
            </AButton>
            <AButton
              variant="primary_filled"
              updatedStyle={{
                height: "28px",
                fontSize: "12px",
                fontWeight: 400,
              }}
              disabled={
                !attachTestForm?.label ||
                (state.isDropdownEnabled && !state.testGroupId)
              }
              onClick={() => {
                updateAttachTestHandler({ attachTestForm, state }, testData);
                closeForm();
              }}
            >
              Attach
            </AButton>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default AttachTestForm;
